// Máy nào trỏ về API của máy đó.
// KHÔNG đặt REACT_APP_API_BASE (đúng trường hợp bản dựng deploy lên VPS) => dùng
// địa chỉ thật bên dưới, nên đường ống deploy hiện tại KHÔNG đổi gì cả.
// Bản chạy ở máy cá nhân đặt biến này trong .env.local để trỏ về localhost.
export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://quan-gia.thpstyle.vn/api";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

// ============================================================
// ⚠️ KHI GỌI MÁY CHỦ THẤT BẠI — 08/09/2026
// ------------------------------------------------------------
// Bản cũ ném đúng một câu cho mọi loại lỗi:
//
//     throw new Error("Lỗi tải dữ liệu");
//
// Máy chủ CÓ gửi câu cụ thể — `{ error: "Không có quyền" }` hoặc
// `{ error: "Lỗi tải danh sách user" }` — và mã số HTTP nói rõ chuyện gì:
// 403 là quyền, 500 là database, 404 là sai đường dẫn. Bản cũ vứt sạch cả
// hai, chỉ giữ lại một câu vô nghĩa.
//
// CHUYỆN THẬT NGÀY 08/09/2026: khu Quản trị báo "Lỗi tải danh sách thành
// viên". Nhìn màn hình không biết được 403 hay 500 — hai hướng tìm khác
// hẳn nhau. Phải nhờ chủ nhà mở F12 xem cột Status. Lỗi tự hết sau đó,
// KHÔNG AI BIẾT VÌ SAO, và nếu nó quay lại thì lại mù y như cũ.
//
// Nay mỗi lần gọi hỏng đều `console.error` đầy đủ: đường dẫn, mã số, câu
// máy chủ gửi về. Lần sau chỉ cần mở F12 → Console là thấy, không phải dò
// từng dòng trong thẻ Network.
//
// Lỗi ném ra cũng mang theo `.status` và `.chiTiet` để màn hình nào muốn
// hiện rõ thì hiện — nhưng KHÔNG ép: các trang vẫn tự chọn câu thân thiện
// của mình. App nói với người trong nhà bằng tiếng người, còn chi tiết kỹ
// thuật để trong Console cho người đi sửa.
// ============================================================
const nemLoi = async (response, duongDan, viecGi) => {
  // 401 = thẻ đăng nhập hết hạn. Dọn thẻ cũ rồi tải lại để về màn đăng nhập.
  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.reload();
  }

  // Đọc câu máy chủ gửi kèm, nếu có. Bọc try/catch vì thân phản hồi có thể
  // rỗng hoặc không phải JSON (ví dụ trang lỗi HTML của IIS khi sai đường dẫn).
  let cauMayChu = "";
  try {
    const than = await response.json();
    if (than && than.error) cauMayChu = String(than.error);
  } catch (e) {
    // không sao — cứ dùng mã số
  }

  console.error(
    `[Quản gia] ${viecGi} thất bại · ${response.status} ${response.statusText}` +
      ` · ${API_BASE}/${duongDan}` +
      (cauMayChu ? ` · máy chủ nói: "${cauMayChu}"` : " · máy chủ không nói gì thêm"),
  );

  const loi = new Error(viecGi);
  loi.status = response.status;
  loi.chiTiet = cauMayChu;
  throw loi;
};

export const fetchData = async (endpoint) => {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    headers: getHeaders(),
  });
  if (!response.ok) await nemLoi(response, endpoint, "Tải dữ liệu");
  return response.json();
};

export const addData = async (endpoint, data) => {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  if (!response.ok) await nemLoi(response, endpoint, "Thêm dữ liệu");
  return response.json();
};

export const deleteData = async (endpoint, id) => {
  const response = await fetch(`${API_BASE}/${endpoint}/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!response.ok) await nemLoi(response, `${endpoint}/${id}`, "Xóa dữ liệu");
  // KHÔNG gọi response.json() ở đây.
  // Máy chủ trả về mã 204 — nghĩa là "đã xóa xong, không có gì để nói thêm" —
  // với thân phản hồi RỖNG. Đọc JSON từ thân rỗng sẽ ném lỗi
  // "Unexpected end of JSON input", khiến màn hình báo "Lỗi khi xóa..."
  // dù thực tế đã xóa thành công, và danh sách không được tải lại.
  return true;
};

export const updateData = async (endpoint, id, data) => {
  const response = await fetch(`${API_BASE}/${endpoint}/${id}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(data),
  });
  // ⚠️ Bản cũ ở đây THIẾU HẲN phần xử lý 401 mà ba hàm trên đều có. Nghĩa là
  // thẻ đăng nhập hết hạn giữa chừng thì mọi thao tác Sửa im lặng thất bại,
  // người dùng cứ bấm Lưu mà không hiểu vì sao không lưu được — trong khi
  // Thêm và Xóa thì đưa họ về màn đăng nhập đàng hoàng. Nay dùng chung một
  // đường như nhau.
  if (!response.ok) await nemLoi(response, `${endpoint}/${id}`, "Cập nhật dữ liệu");
  return response.json();
};

// ============================================================
// 📷 ẢNH VÀ TỆP TẢI VỀ (Đợt N5, 14/09/2026)
// ------------------------------------------------------------
// ⚠️ XEM ẢNH PHẢI ĐĂNG NHẬP (anh chốt). Thẻ <img src="/api/anh/5"> KHÔNG gửi
// được thẻ đăng nhập, nên ảnh phải lấy bằng fetch (kèm thẻ) rồi mới vẽ.
// KHÔNG nối thẻ đăng nhập vào đường link ảnh cho tiện — link lọt vào nhật ký
// IIS, lịch sử trình duyệt, ảnh chụp màn hình.
// ============================================================
const theDangNhap = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/** Gửi byte ảnh JPEG trơn (không bọc JSON — base64 phình thêm 33% dung lượng). */
export const guiAnh = async (endpoint, blob) => {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    method: "POST",
    headers: { ...theDangNhap(), "Content-Type": "image/jpeg" },
    body: blob,
  });
  if (!response.ok) await nemLoi(response, endpoint, "Gửi ảnh");
  return response.json();
};

/** Lấy một tệp (ảnh, zip, bản sao lưu) về dạng Blob, kèm thẻ đăng nhập. */
export const layBlob = async (endpoint) => {
  const response = await fetch(`${API_BASE}/${endpoint}`, { headers: theDangNhap() });
  if (!response.ok) await nemLoi(response, endpoint, "Tải tệp");
  return {
    blob: await response.blob(),
    tenTep: tenTepTuPhanHoi(response),
    // Mốc máy chủ đóng gói ảnh tháng — gửi lại khi báo "đã lưu" (N5)
    moc: response.headers.get("x-moc-tai"),
  };
};

const tenTepTuPhanHoi = (response) => {
  const cd = response.headers.get("content-disposition") || "";
  const m = cd.match(/filename="?([^";]+)"?/i);
  return m ? m[1] : null;
};

// ============================================================
// 💾 LƯU TỆP CỦA QUẢN GIA VỀ ĐÚNG CHỖ, VÀ BIẾT CHẮC ĐÃ LƯU (sau deploy N5, 14/09)
// ------------------------------------------------------------
// Hai chuyện anh Hùng gặp khi thử thật:
//   1. *"Thư mục tải về lộn xộn quá"* → anh chốt cất về D:\SaoLuu\QuanGia
//      (CoSoDuLieu cho bản sao lưu, Anh cho zip ảnh).
//   2. Hộp "Lưu như" còn mở (hoặc bị Hủy) mà app đã ghi "đã cất".
//
// Cách giải cả hai: `showSaveFilePicker` (Chrome, Cốc Cốc, Edge trên máy tính).
//   • `id` riêng cho từng loại tệp → trình duyệt NHỚ THƯ MỤC RIÊNG cho loại đó,
//     không lẫn với các lượt tải khác. Lần đầu anh chọn thư mục, lần sau tự mở
//     đúng chỗ.
//   • Hộp chọn chỗ hiện TRƯỚC khi tải; ghi tệp xong (`close()`) mới trả về
//     "đã lưu". Bấm Hủy → trả về "hủy", app không ghi sổ gì.
//
// ⚠️ Phải gọi hộp chọn chỗ NGAY trong cú bấm, trước mọi `await` — trình duyệt
// chỉ cho mở hộp này khi đang có thao tác bấm của người dùng.
//
// Trình duyệt không có hộp này (iPhone, Safari) → tải kiểu thường rồi HỎI một
// câu "đã lưu xong chưa?". Không đoán thay người dùng.
// ============================================================
const taiKieuThuong = (blob, ten) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = ten;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Đợi trình duyệt nhận tệp xong mới thu hồi, không thì Safari tải về tệp rỗng.
  setTimeout(() => URL.revokeObjectURL(url), 60 * 1000);
};

/**
 * @param {object} o
 * @param {string} o.endpoint   đường tải trên máy chủ
 * @param {string} o.tenGoiY    tên tệp gợi ý
 * @param {string} o.idCho      mã nhớ thư mục riêng ("quan-gia-sao-luu" / "quan-gia-anh")
 * @param {string} o.moTa       mô tả loại tệp trong hộp Lưu như
 * @param {string} o.duoi       ".zip" / ".backup"
 * @returns {Promise<{ketQua: "da-luu"|"huy", soByte?: number, moc?: string, tenTep?: string}>}
 */
export const luuTepQuanGia = async ({ endpoint, tenGoiY, idCho, moTa, duoi }) => {
  if (typeof window.showSaveFilePicker === "function") {
    let cho;
    try {
      cho = await window.showSaveFilePicker({
        id: idCho,
        suggestedName: tenGoiY,
        startIn: "downloads",
        types: [{ description: moTa, accept: { "application/octet-stream": [duoi] } }],
      });
    } catch (err) {
      if (err && err.name === "AbortError") return { ketQua: "huy" };
      cho = null; // trình duyệt chặn hộp chọn chỗ → đi đường tải thường bên dưới
    }
    if (cho) {
      const { blob, moc } = await layBlob(endpoint);
      const ghi = await cho.createWritable();
      await ghi.write(blob);
      await ghi.close(); // xong dòng này tệp mới thật sự nằm trên máy
      return { ketQua: "da-luu", soByte: blob.size, moc, tenTep: cho.name };
    }
  }

  const { blob, tenTep, moc } = await layBlob(endpoint);
  taiKieuThuong(blob, tenTep || tenGoiY);
  const daLuu = window.confirm(
    `Trình duyệt đang tải "${tenTep || tenGoiY}".\n\n` +
      "Bấm OK khi đã LƯU XONG tệp vào máy.\nBấm Hủy nếu chưa lưu (lát bấm tải lại).",
  );
  return daLuu
    ? { ketQua: "da-luu", soByte: blob.size, moc, tenTep: tenTep || tenGoiY }
    : { ketQua: "huy" };
};
